// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"not-found_errorWrapper__ESdT7"};